var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { axiosPrivate } from "../../api/axios";
import { GiftCardText } from "./GiftCardApplyForm-types";
export const giftCardFormSubmit = (toast, closeModal, setOrderInfo, setBalance, updatePayInitiation, orderInfo) => (data) => {
    ApplyGiftCard(data.giftCardNumber, toast, closeModal, setOrderInfo, setBalance, updatePayInitiation, orderInfo);
};
export const ApplyGiftCard = (giftCardNumber, toast, closeModal, setOrderInfo, setBalance, updatePayInitiation, orderInfo) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield axiosPrivate.post(`/React/ApplyGiftCard?giftCardNumber=${giftCardNumber}`, orderInfo);
    if (res.data.error) {
        toast.push(GiftCardText.GIFT_CARD_NOT_FOUND, { variant: "error" });
        return;
    }
    if (res.data.success) {
        const balance = res.data.balance;
        setOrderInfo(res.data.orderInfo);
        setBalance(balance);
        updatePayInitiation(balance.remainingBalance);
        toast.push(res.data.responseMsg, { variant: "success" });
        closeModal();
    }
    else {
        toast.push(res.data.responseMsg, { variant: "error" });
    }
});
